(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mapl-announcement-wave"] && !Shopify.designMode) return;
  try {
    
  if (!window.MaplAnnouncementBarNativeBooted) {
    window.MaplAnnouncementBarNativeBooted = true;

    class MaplAnnouncementBarNative {
      constructor(root) {
        this.root = root;
        this.slides = Array.from(root.querySelectorAll('[data-mapl-announcement-slide]'));
        this.index = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
        this.pendingIndex = null;
        this.autoplay = root.dataset.autoplay === 'true';
        this.delay = Math.max(1000, Number(root.dataset.delay) * 1000);
        this.speed = Math.max(200, Number(root.dataset.speed) * 1000);
        this.stagger = Math.max(0, Number(root.dataset.stagger));
        this.bounce = Math.max(1, Number(root.dataset.bounce));
        this.timer = null;
        this.animations = new Set();
        this.runId = 0;
        this.animating = false;
        this.destroyed = false;
        this.focusPaused = false;
        this.editorPaused = false;
        this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.segmenter = 'Segmenter' in Intl
          ? new Intl.Segmenter(document.documentElement.lang || 'en', { granularity: 'grapheme' })
          : null;
        this.onFocusIn = () => {
          this.focusPaused = true;
          this.stop();
        };
        this.onFocusOut = (event) => {
          if (!this.root.contains(event.relatedTarget)) {
            this.focusPaused = false;
            this.schedule();
          }
        };
        this.onVisibilityChange = () => {
          if (document.hidden) {
            this.stop();
          } else {
            this.schedule();
          }
        };
        this.onMotionChange = () => {
          const target = this.pendingIndex === null ? this.index : this.pendingIndex;
          this.showImmediate(target);
        };

        this.prepareLetters();
        this.bind();
        this.showImmediate(this.index);
        this.playInitialWave();
      }

      splitGraphemes(text) {
        if (this.segmenter) {
          return Array.from(this.segmenter.segment(text), (item) => item.segment);
        }

        return Array.from(text);
      }

      prepareLetters() {
        this.slides.forEach((slide) => {
          const letters = slide.querySelector('[data-mapl-announcement-letters]');
          if (!letters) return;

          const parts = letters.textContent.split(/(\s+)/);
          const fragment = document.createDocumentFragment();

          parts.forEach((part) => {
            if (!part) return;

            if (/^\s+$/.test(part)) {
              fragment.appendChild(document.createTextNode(part));
              return;
            }

            const word = document.createElement('span');
            word.className = 'mapl-announcement__word';

            this.splitGraphemes(part).forEach((character) => {
              const characterElement = document.createElement('span');
              characterElement.className = 'mapl-announcement__character';
              characterElement.dataset.maplAnnouncementCharacter = '';
              characterElement.textContent = character;
              word.appendChild(characterElement);
            });

            fragment.appendChild(word);
          });

          letters.replaceChildren(fragment);
        });
      }

      bind() {
        this.root.addEventListener('focusin', this.onFocusIn);
        this.root.addEventListener('focusout', this.onFocusOut);
        document.addEventListener('visibilitychange', this.onVisibilityChange);
        this.motionQuery.addEventListener('change', this.onMotionChange);
      }

      characters(slide) {
        return Array.from(slide.querySelectorAll('[data-mapl-announcement-character]'));
      }

      prepareForWave(slide) {
        this.characters(slide).forEach((character) => {
          character.style.opacity = '0';
          character.style.transform = 'translateY(65%) scaleY(0.96)';
        });
      }

      resetCharacters(slide) {
        this.characters(slide).forEach((character) => {
          character.style.removeProperty('opacity');
          character.style.removeProperty('transform');
        });
      }

      startRun() {
        this.runId += 1;
        this.cancelAnimations();
        return this.runId;
      }

      track(animation) {
        this.animations.add(animation);
        return animation.finished.catch(() => undefined);
      }

      cancelAnimations() {
        this.animations.forEach((animation) => animation.cancel());
        this.animations.clear();
      }

      letterWave(slide) {
        const characters = this.characters(slide);
        const duration = Math.max(420, this.speed * 0.85);
        const overshoot = Math.min(18, 5 + this.bounce * 4);

        return characters.map((character, characterIndex) => {
          const animation = character.animate(
            [
              {
                transform: 'translateY(65%) scaleY(0.96)',
                opacity: 0,
                offset: 0
              },
              {
                transform: `translateY(-${overshoot}%) scaleY(1.02)`,
                opacity: 1,
                offset: 0.58
              },
              {
                transform: `translateY(${overshoot * 0.42}%) scaleY(0.99)`,
                opacity: 1,
                offset: 0.76
              },
              {
                transform: `translateY(-${overshoot * 0.18}%) scaleY(1.01)`,
                opacity: 1,
                offset: 0.9
              },
              {
                transform: 'translateY(0) scaleY(1)',
                opacity: 1,
                offset: 1
              }
            ],
            {
              duration,
              delay: characterIndex * this.stagger,
              easing: 'cubic-bezier(0.2, 0.75, 0.25, 1)',
              fill: 'both'
            }
          );

          return this.track(animation);
        });
      }

      fadeOut(slide) {
        return this.track(
          slide.animate(
            [
              { opacity: 1 },
              { opacity: 0 }
            ],
            {
              duration: Math.max(160, this.speed * 0.45),
              easing: 'ease-in-out',
              fill: 'both'
            }
          )
        );
      }

      async playInitialWave() {
        if (this.motionQuery.matches || this.slides.length === 0) {
          this.schedule();
          return;
        }

        this.stop();
        const token = this.startRun();
        this.animating = true;
        this.prepareForWave(this.slides[this.index]);
        const wave = this.letterWave(this.slides[this.index]);
        await Promise.all(wave);

        if (this.destroyed || token !== this.runId) return;

        this.cancelAnimations();
        this.resetCharacters(this.slides[this.index]);
        this.animating = false;
        this.schedule();
      }

      canRotate() {
        return this.autoplay
          && this.slides.length > 1
          && !this.motionQuery.matches
          && !document.hidden
          && !this.focusPaused
          && !this.editorPaused
          && !this.animating
          && !this.destroyed;
      }

      schedule() {
        this.stop();

        if (!this.canRotate()) return;

        this.timer = window.setTimeout(() => {
          this.goTo((this.index + 1) % this.slides.length);
        }, this.delay);
      }

      stop() {
        window.clearTimeout(this.timer);
        this.timer = null;
      }

      showImmediate(index) {
        if (!this.slides[index]) return;

        this.stop();
        this.startRun();
        this.animating = false;
        this.pendingIndex = null;

        this.slides.forEach((slide, slideIndex) => {
          const active = slideIndex === index;
          this.resetCharacters(slide);
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });

        this.index = index;
        this.schedule();
      }

      async goTo(index) {
        if (this.animating || index === this.index || !this.slides[index]) return;

        this.stop();
        this.animating = true;
        this.pendingIndex = index;
        const token = this.startRun();
        const current = this.slides[this.index];
        const next = this.slides[index];

        await this.fadeOut(current);

        if (this.destroyed || token !== this.runId) return;

        this.cancelAnimations();
        current.classList.remove('is-active');
        current.setAttribute('aria-hidden', 'true');
        this.prepareForWave(next);
        next.classList.add('is-active');
        next.setAttribute('aria-hidden', 'false');

        const wave = this.letterWave(next);
        await Promise.all(wave);

        if (this.destroyed || token !== this.runId) return;

        this.cancelAnimations();
        this.resetCharacters(next);
        this.index = index;
        this.pendingIndex = null;
        this.animating = false;
        this.schedule();
      }

      selectBlock(slide) {
        const index = this.slides.indexOf(slide);
        if (index === -1) return;

        this.editorPaused = true;
        this.showImmediate(index);
      }

      releaseEditorPause() {
        this.editorPaused = false;
        this.schedule();
      }

      destroy() {
        this.destroyed = true;
        this.stop();
        this.runId += 1;
        this.cancelAnimations();
        this.root.removeEventListener('focusin', this.onFocusIn);
        this.root.removeEventListener('focusout', this.onFocusOut);
        document.removeEventListener('visibilitychange', this.onVisibilityChange);
        this.motionQuery.removeEventListener('change', this.onMotionChange);
      }
    }

    const rootsWithin = (scope) => {
      const roots = [];

      if (scope.matches && scope.matches('[data-mapl-announcement]')) {
        roots.push(scope);
      }

      if (scope.querySelectorAll) {
        roots.push(...scope.querySelectorAll('[data-mapl-announcement]'));
      }

      return roots;
    };

    const initialize = (root) => {
      if (root.maplAnnouncementNativeBar || !document.documentElement.contains(root)) return;

      if (root.maplAnnouncementBar) {
        root.maplAnnouncementBar.destroy();
        delete root.maplAnnouncementBar;
      }

      root.maplAnnouncementNativeBar = new MaplAnnouncementBarNative(root);
    };

    const initializeWithin = (scope) => {
      rootsWithin(scope).forEach((root) => initialize(root));
    };

    const destroyWithin = (scope) => {
      rootsWithin(scope).forEach((root) => {
        if (root.maplAnnouncementNativeBar) root.maplAnnouncementNativeBar.destroy();
        delete root.maplAnnouncementNativeBar;
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeWithin(document), { once: true });
    } else {
      initializeWithin(document);
    }

    document.addEventListener('shopify:section:load', (event) => initializeWithin(event.target));
    document.addEventListener('shopify:section:unload', (event) => destroyWithin(event.target));
    document.addEventListener('shopify:block:select', (event) => {
      const slide = event.target.closest('[data-mapl-announcement-slide]');
      if (!slide) return;

      const root = slide.closest('[data-mapl-announcement]');
      if (root && root.maplAnnouncementNativeBar) {
        root.maplAnnouncementNativeBar.selectBlock(slide);
      }
    });
    document.addEventListener('shopify:block:deselect', (event) => {
      const root = event.target.closest('[data-mapl-announcement]');
      if (root && root.maplAnnouncementNativeBar) {
        root.maplAnnouncementNativeBar.releaseEditorPause();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mapl-product-nutrition"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mapl-inside')) {
    customElements.define('mapl-inside', class extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.abort = new AbortController();
        this.panels = [...this.querySelectorAll('[data-flavour-panel]')];
        if (!this.panels.length) return;
        this.selectFlavour(this.panels[0].dataset.flavourPanel);
        this.dataset.ready = '';
        this.paused = false;
        this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
        this.visible = false;
        this.updateMotion = () => {
          this.dataset.motion = this.visible && !this.paused && !this.reducedMotion.matches && !document.hidden ? 'running' : 'paused';
        };
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          this.updateMotion();
        });
        this.observer.observe(this);
        this.reducedMotion.addEventListener('change', this.updateMotion, { signal: this.abort.signal });
        document.addEventListener('visibilitychange', this.updateMotion, { signal: this.abort.signal });
        this.addEventListener('click', event => {
          const flavour = event.target.closest('[data-flavour]');
          if (flavour) return this.selectFlavour(flavour.dataset.flavour);
          const motion = event.target.closest('[data-motion-toggle]');
          if (motion) {
            this.paused = !this.paused;
            motion.setAttribute('aria-pressed', String(this.paused));
            motion.textContent = this.paused ? motion.dataset.play : motion.dataset.pause;
            this.updateMotion();
          }
        }, { signal: this.abort.signal });
        this.addEventListener('shopify:block:select', event => {
          const panel = event.target.closest('[data-flavour-panel]');
          if (panel) this.selectFlavour(panel.dataset.flavourPanel);
        }, { signal: this.abort.signal });
      }
      selectFlavour(id) {
        this.panels.forEach(panel => { panel.hidden = panel.dataset.flavourPanel !== id; });
        this.querySelectorAll('[data-flavour]').forEach(button => {
          button.setAttribute('aria-pressed', String(button.dataset.flavour === id));
        });
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.observer?.disconnect();
        this.abort = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mapl-shop-launch"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const bind = (root = document) => {
      root.querySelectorAll('[data-mapl-variant-select]').forEach((select) => {
        if (select.dataset.maplBound === 'true') return;
        select.dataset.maplBound = 'true';
        select.addEventListener('change', () => {
          const option = select.options[select.selectedIndex];
          const form = select.closest('form');
          if (!form || !option) return;
          const price = form.querySelector('[data-mapl-price]');
          const perCan = form.querySelector('[data-mapl-per-can]');
          if (price) price.textContent = option.dataset.price || '';
          if (perCan) perCan.textContent = option.dataset.perCan || '';
        });
      });
    };
    bind();
    document.addEventListener('shopify:section:load', (event) => bind(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
